(function () {
  // ==========================================================================
  // Pedido rascunho do Catálogo Cliente.
  // Não usa o carrinho nativo do Shopify: guarda as quantidades escolhidas na
  // grade (cor x tamanho) localmente e, ao finalizar, envia para uma function
  // serverless (Vercel) que cria um Draft Order de verdade via Admin API.
  // Depois disso, abre o WhatsApp da loja com o número do rascunho, o nome do
  // cliente e o link do WhatsApp do cliente, para a vendedora fechar rápido.
  // ==========================================================================

  var CONFIG = {
    apiEndpoint: 'https://dashboard-uma-bala.vercel.app/api/catalogo/draft-order',
    storeWhatsapp: '5511944683337'
  };

  var STORAGE_KEY = 'catalogoDraftCart:v1';
  var state = {};

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      state = raw ? JSON.parse(raw) || {} : {};
    } catch (e) {
      state = {};
    }
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      // localStorage indisponível (modo privado, etc.) - segue apenas em memória
    }
  }

  function totalItems() {
    var total = 0;
    Object.keys(state).forEach(function (id) {
      total += state[id].quantity || 0;
    });
    return total;
  }

  function totalPriceCents() {
    var total = 0;
    Object.keys(state).forEach(function (id) {
      total += (state[id].quantity || 0) * (state[id].price || 0);
    });
    return total;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function formatTotalLabel() {
    return 'peças: ' + totalItems() + '   ' + formatMoney(totalPriceCents());
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function readInputData(input) {
    return {
      variantId: input.dataset.variantId,
      variantTitle: input.dataset.variantTitle,
      maxStock: parseInt(input.dataset.maxStock, 10) || 9999,
      productId: input.dataset.productId,
      productTitle: input.dataset.productTitle,
      productHandle: input.dataset.productHandle,
      productUrl: input.dataset.productUrl,
      color: input.dataset.color,
      size: input.dataset.size,
      price: parseInt(input.dataset.price, 10) || 0,
      image: input.dataset.image
    };
  }

  // Estoque real e limitado (maxStock < 9999 é o "sentinela" de estoque
  // ilimitado/sem controle de inventário - ver max_stock no snippet Liquid).
  function isAtMaxStock(input, qty) {
    var maxStock = parseInt(input.dataset.maxStock, 10) || 9999;
    return maxStock < 9999 && qty >= maxStock;
  }

  function syncAllInputsForVariant(variantId, qty) {
    document
      .querySelectorAll('.catalogo-quantity-input[data-variant-id="' + variantId + '"]')
      .forEach(function (el) {
        if (parseInt(el.value, 10) !== qty) {
          el.value = qty;
        }
        el.classList.toggle('quantity-zero', qty === 0);
        el.classList.toggle('quantity-max-stock', isAtMaxStock(el, qty));
      });
  }

  function syncInputsFromState(root) {
    (root || document).querySelectorAll('.catalogo-quantity-input').forEach(function (input) {
      var id = input.dataset.variantId;
      var item = state[id];
      var qty = item ? item.quantity : 0;
      input.value = qty;
      input.classList.toggle('quantity-zero', qty === 0);
      input.classList.toggle('quantity-max-stock', isAtMaxStock(input, qty));
    });
  }

  function setQuantity(input, qty) {
    var data = readInputData(input);
    qty = Math.max(0, Math.min(qty, data.maxStock));

    if (qty === 0) {
      delete state[data.variantId];
    } else {
      data.quantity = qty;
      state[data.variantId] = data;
    }

    saveState();
    syncAllInputsForVariant(data.variantId, qty);
    renderPanel();
    updateFloatingButton();
    return qty;
  }

  // ===== Interação: clique incrementa, segurar (long-press) zera =====
  var longPressTimer = null;
  var wasLongPress = false;
  var LONG_PRESS_DELAY = 450;

  function handleClick(input) {
    var current = parseInt(input.value, 10) || 0;
    var maxStock = parseInt(input.dataset.maxStock, 10) || 9999;
    var next = Math.min(current + 1, maxStock);
    var applied = setQuantity(input, next);

    input.classList.add('quantity-clicked');
    setTimeout(function () {
      input.classList.remove('quantity-clicked');
    }, 200);

    if (applied >= maxStock) {
      showMaxStockMessage(input);
    }
  }

  function handleLongPressStart(input) {
    wasLongPress = false;
    longPressTimer = setTimeout(function () {
      wasLongPress = true;
      setQuantity(input, 0);
      input.classList.add('quantity-reset');
      setTimeout(function () {
        input.classList.remove('quantity-reset');
      }, 300);
      if ('vibrate' in navigator) {
        try {
          navigator.vibrate([30, 50, 30]);
        } catch (e) {
          // ignorar
        }
      }
    }, LONG_PRESS_DELAY);
  }

  function handleLongPressEnd() {
    if (longPressTimer) {
      clearTimeout(longPressTimer);
      longPressTimer = null;
    }
  }

  function showMaxStockMessage(input) {
    var wrapper = input.closest('.catalogo-quantity-cell-wrapper');
    if (!wrapper) return;
    var msg = wrapper.querySelector('.catalogo-max-stock-message');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'catalogo-max-stock-message';
      wrapper.appendChild(msg);
    }
    msg.textContent = 'MÁXIMO DISPONÍVEL';
    msg.classList.add('is-visible');
    setTimeout(function () {
      msg.classList.remove('is-visible');
    }, 1800);
  }

  // isTouchDevice: mesmo truque do product-grid-matrix.js/cart-drawer.js.
  // Sem isso, um toque real dispara touchstart/touchend E, ~300ms depois, o
  // navegador sintetiza mousedown/mouseup "fantasma" pra compatibilidade -
  // como os dois conjuntos de listeners rodavam independentes, cada toque
  // real virava 2 incrementos, e um "segurar pra zerar" ainda disparava um
  // clique extra logo depois (o mouseup fantasma reiniciava o long-press do
  // zero, via handleLongPressStart, e como ele nunca fica pressionado por
  // 450ms, sempre cai no incremento). Uma vez detectado touch no aparelho,
  // os eventos de mouse passam a ser ignorados nesses inputs.
  function bindGridInteractions() {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchMoved = false;
    var isTouchDevice = false;

    document.addEventListener('mousedown', function (e) {
      if (isTouchDevice) return;
      var input = e.target.closest('.catalogo-quantity-input');
      if (!input) return;
      handleLongPressStart(input);
    });

    document.addEventListener('mouseup', function (e) {
      if (isTouchDevice) return;
      var input = e.target.closest('.catalogo-quantity-input');
      if (!input) return;
      handleLongPressEnd();
      if (!wasLongPress) handleClick(input);
      wasLongPress = false;
    });

    document.addEventListener(
      'touchstart',
      function (e) {
        var input = e.target.closest('.catalogo-quantity-input');
        if (!input) return;
        isTouchDevice = true;
        var t = e.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
        touchMoved = false;
        // Impede o "ghost click"/mousedown-mouseup sintéticos e o duplo-toque
        // de zoom do navegador nesse elemento.
        e.preventDefault();
        handleLongPressStart(input);
      },
      { passive: false }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        if (touchMoved || !e.touches.length) return;
        var t = e.touches[0];
        if (Math.abs(t.clientX - touchStartX) > 10 || Math.abs(t.clientY - touchStartY) > 10) {
          touchMoved = true;
          handleLongPressEnd();
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (e) {
        var input = e.target.closest('.catalogo-quantity-input');
        if (!input) return;
        if (!touchMoved) e.preventDefault();
        handleLongPressEnd();
        if (!wasLongPress && !touchMoved) handleClick(input);
        wasLongPress = false;
        touchMoved = false;
      },
      { passive: false }
    );

    document.addEventListener('touchcancel', function () {
      handleLongPressEnd();
      wasLongPress = false;
      touchMoved = false;
    });

    // No celular, o navegador dá zoom automático ao focar um input com
    // fonte pequena. Como esses inputs só servem de "botão" (readonly, sem
    // teclado), tiramos o foco na hora - mesmo truque já usado em
    // cart-drawer.js e product-grid-matrix.js pra evitar esse zoom chato.
    // 'focusin' (que borbulha) em vez de 'focus' pra funcionar via delegação.
    document.addEventListener('focusin', function (e) {
      var input = e.target.closest('.catalogo-quantity-input');
      if (input) input.blur();
    });
  }

  // Mostra/esconde a grade dentro do card OU dentro do painel "Meu pedido"
  // (mesmo padrão do botão "Ver estoque"), usando o ancestral comum mais
  // próximo em qualquer um dos dois contextos.
  function bindGridToggle() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-catalogo-cliente-toggle]');
      if (!toggle) return;

      var scope = toggle.closest('[data-catalogo-item], .catalogo-draft-cart-panel__product');
      var grid = scope && scope.querySelector('[data-catalogo-cliente-grid]');
      if (!grid) return;

      var isHidden = grid.hidden;
      grid.hidden = !isHidden;
      toggle.textContent = isHidden ? 'Ocultar grade' : 'Montar pedido';
    });
  }

  // ===== Painel "Meu pedido" =====

  function buildPanelMarkup() {
    var wrapper = document.createElement('div');
    wrapper.innerHTML =
      '<button type="button" id="catalogo-draft-cart-fab" class="catalogo-draft-cart-fab" hidden>' +
        '<span class="svg-wrapper">' + cartIconSvg() + '</span>' +
        '<span class="catalogo-draft-cart-fab__label">Meu pedido</span>' +
        '<span class="catalogo-draft-cart-fab__count" id="catalogo-draft-cart-count">0</span>' +
      '</button>' +
      '<div id="catalogo-draft-cart-overlay" class="catalogo-draft-cart-overlay" hidden></div>' +
      '<aside id="catalogo-draft-cart-panel" class="catalogo-draft-cart-panel" hidden role="dialog" aria-modal="true" aria-label="Meu pedido">' +
        '<div class="catalogo-draft-cart-panel__header">' +
          '<button type="button" id="catalogo-draft-cart-close" aria-label="Fechar">&times;</button>' +
        '</div>' +
        '<div id="catalogo-draft-cart-items" class="catalogo-draft-cart-panel__items"></div>' +
        '<div class="catalogo-draft-cart-panel__footer">' +
          '<div class="catalogo-draft-cart-panel__total">' +
            '<span>Total:</span>' +
            '<strong id="catalogo-draft-cart-total">peças: 0 &nbsp; R$ 0,00</strong>' +
          '</div>' +
          '<form id="catalogo-draft-cart-form" novalidate>' +
            '<div class="catalogo-draft-cart-field">' +
              '<label class="catalogo-draft-cart-field__label" for="catalogo-draft-cart-name">Identifique-se</label>' +
              '<input type="text" id="catalogo-draft-cart-name" class="catalogo-draft-cart-field__input" name="name" autocomplete="name" placeholder="Seu nome ou da sua loja">' +
            '</div>' +
            '<div class="catalogo-draft-cart-field">' +
              '<label class="catalogo-draft-cart-field__label" for="catalogo-draft-cart-whatsapp">Seu WhatsApp</label>' +
              '<input type="tel" id="catalogo-draft-cart-whatsapp" class="catalogo-draft-cart-field__input" name="whatsapp" autocomplete="tel" placeholder="(11) 91234-5678">' +
            '</div>' +
            '<p id="catalogo-draft-cart-error" class="catalogo-draft-cart-panel__error" role="alert"></p>' +
            '<div class="catalogo-draft-cart-panel__actions">' +
              '<button type="button" id="catalogo-draft-cart-back" class="catalogo-draft-cart-panel__submit catalogo-draft-cart-panel__submit--secondary">Voltar ao catálogo</button>' +
              '<button type="submit" id="catalogo-draft-cart-submit" class="catalogo-draft-cart-panel__submit">Finalizar pedido</button>' +
            '</div>' +
          '</form>' +
          '<div id="catalogo-draft-cart-success" class="catalogo-draft-cart-panel__success" hidden></div>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(wrapper);
  }

  function cartIconSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
  }

  // Mesmo ícone de lixeira já usado em cart-drawer.js (matrix-product-remove).
  function trashIconSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" width="16" height="16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>';
  }

  // O painel mostra, por produto, a MESMA grade cor x tamanho já renderizada
  // no card (clonada, não reconstruída) - igual ao carrinho lateral do fluxo
  // normal com login, que também mostra a grade completa de cada produto
  // (não só as variantes escolhidas), permitindo ajustar direto por ali.
  // Como os cliques são delegados no document, os inputs clonados já
  // funcionam sozinhos e ficam sincronizados com os inputs do card via
  // syncAllInputsForVariant (que atualiza todo mundo com o mesmo variant-id).
  function renderPanel() {
    var container = document.getElementById('catalogo-draft-cart-items');
    if (!container) return;

    var ids = Object.keys(state);
    if (ids.length === 0) {
      container.innerHTML = '<p class="catalogo-draft-cart-panel__empty">Nenhum item selecionado ainda. Toque nas quantidades da grade para montar seu pedido.</p>';
      var totalEl = document.getElementById('catalogo-draft-cart-total');
      if (totalEl) totalEl.textContent = formatTotalLabel();
      return;
    }

    var productIds = [];
    var seen = {};
    ids.forEach(function (id) {
      var pid = state[id].productId;
      if (!seen[pid]) {
        seen[pid] = true;
        productIds.push(pid);
      }
    });

    container.innerHTML = '';

    productIds.forEach(function (pid) {
      var anyItem = state[ids.filter(function (id) { return state[id].productId === pid; })[0]];
      var sourceGrid = document.querySelector('.catalogo-simples-item[data-product-id="' + pid + '"] [data-catalogo-cliente-grid]');
      if (!sourceGrid) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'catalogo-draft-cart-panel__product';

      var header = document.createElement('div');
      header.className = 'catalogo-draft-cart-panel__product-header';
      header.innerHTML =
        (anyItem.image ? '<span class="catalogo-draft-cart-panel__product-img"><img src="' + anyItem.image + '" alt=""></span>' : '') +
        '<span class="catalogo-draft-cart-panel__product-title">' + escapeHtml(anyItem.productTitle) + '</span>' +
        '<button type="button" class="catalogo-simples-stock-toggle catalogo-draft-cart-panel__product-toggle" data-catalogo-cliente-toggle>Ocultar grade</button>' +
        '<button type="button" class="catalogo-draft-cart-panel__product-remove" data-remove-product="' + pid + '" aria-label="Remover produto do pedido">' + trashIconSvg() + '</button>';
      wrapper.appendChild(header);

      var gridClone = sourceGrid.cloneNode(true);
      gridClone.hidden = false;
      wrapper.appendChild(gridClone);

      container.appendChild(wrapper);
    });

    var totalEl = document.getElementById('catalogo-draft-cart-total');
    if (totalEl) totalEl.textContent = formatTotalLabel();
  }

  function updateFloatingButton() {
    var fab = document.getElementById('catalogo-draft-cart-fab');
    var countEl = document.getElementById('catalogo-draft-cart-count');
    if (!fab || !countEl) return;
    var count = totalItems();
    countEl.textContent = count;
    fab.hidden = count === 0 && !panelIsOpen();
  }

  function panelIsOpen() {
    var panel = document.getElementById('catalogo-draft-cart-panel');
    return panel && !panel.hidden;
  }

  function openPanel() {
    var panel = document.getElementById('catalogo-draft-cart-panel');
    var overlay = document.getElementById('catalogo-draft-cart-overlay');
    var fab = document.getElementById('catalogo-draft-cart-fab');
    if (!panel || !overlay) return;
    renderPanel();
    panel.hidden = false;
    overlay.hidden = false;
    if (fab) fab.hidden = false;
    document.body.classList.add('catalogo-draft-cart-open');
  }

  function closePanel() {
    var panel = document.getElementById('catalogo-draft-cart-panel');
    var overlay = document.getElementById('catalogo-draft-cart-overlay');
    if (!panel || !overlay) return;
    panel.hidden = true;
    overlay.hidden = true;
    document.body.classList.remove('catalogo-draft-cart-open');
    updateFloatingButton();
  }

  function removeProduct(productId) {
    Object.keys(state).forEach(function (id) {
      if (state[id].productId === productId) {
        delete state[id];
        syncAllInputsForVariant(id, 0);
      }
    });
    saveState();
    renderPanel();
    updateFloatingButton();
  }

  function handleFinalizeSubmit(e) {
    e.preventDefault();

    var nameInput = document.getElementById('catalogo-draft-cart-name');
    var whatsInput = document.getElementById('catalogo-draft-cart-whatsapp');
    var errorEl = document.getElementById('catalogo-draft-cart-error');
    var submitBtn = document.getElementById('catalogo-draft-cart-submit');

    errorEl.textContent = '';

    var name = nameInput.value.trim();
    var digits = whatsInput.value.replace(/\D/g, '');

    if (!name) {
      errorEl.textContent = 'Informe seu nome.';
      return;
    }
    if (digits.length < 10) {
      errorEl.textContent = 'Informe um WhatsApp válido com DDD.';
      return;
    }

    var ids = Object.keys(state);
    if (ids.length === 0) {
      errorEl.textContent = 'Selecione ao menos um item na grade antes de finalizar.';
      return;
    }

    if (!CONFIG.apiEndpoint) {
      errorEl.textContent = 'Finalização ainda não configurada. Fale com a loja.';
      console.error('catalogo-draft-cart: CONFIG.apiEndpoint não foi definido.');
      return;
    }

    var items = ids.map(function (id) {
      return { variant_id: id, quantity: state[id].quantity };
    });

    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando pedido...';

    fetch(CONFIG.apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_name: name, whatsapp: digits, items: items })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Finalizar pedido';

        if (!result.ok) {
          errorEl.textContent = (result.data && result.data.error) || 'Não foi possível enviar seu pedido. Tente novamente.';
          return;
        }

        var draftName = (result.data && result.data.draft_name) || '';
        var message =
          'Novo pedido pelo catálogo!\n' +
          'Rascunho: ' + draftName + '\n' +
          'Cliente: ' + name + '\n' +
          'WhatsApp do cliente: https://wa.me/' + digits;
        var waUrl = 'https://wa.me/' + CONFIG.storeWhatsapp + '?text=' + encodeURIComponent(message);

        state = {};
        saveState();
        syncInputsFromState();
        renderPanel();
        updateFloatingButton();
        showSuccessState(draftName, waUrl);

        // window.open() abre o link em nova aba/janela, e o iOS só entrega
        // esse tipo de link (wa.me) pro app nativo do WhatsApp quando é a
        // própria aba atual que navega pra lá (Universal Link) - como isso
        // roda depois do fetch (assíncrono, fora do toque original do
        // usuário), window.open acaba caindo só no Safari/navegador em vez
        // de abrir o app. location.href resolve isso de forma confiável.
        window.location.href = waUrl;
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Finalizar pedido';
        errorEl.textContent = 'Erro de conexão. Tente novamente.';
      });
  }

  function showSuccessState(draftName, waUrl) {
    var form = document.getElementById('catalogo-draft-cart-form');
    var successEl = document.getElementById('catalogo-draft-cart-success');
    if (!form || !successEl) return;
    form.hidden = true;
    successEl.hidden = false;
    successEl.innerHTML =
      '<p>Pedido enviado! ' + (draftName ? 'Rascunho <strong>' + escapeHtml(draftName) + '</strong>.' : '') + '</p>' +
      '<p>Abrimos o WhatsApp para você falar com a gente. Se não abriu, ' +
      '<a href="' + waUrl + '" target="_blank" rel="noopener">clique aqui</a>.</p>' +
      '<button type="button" id="catalogo-draft-cart-new-order" class="catalogo-draft-cart-panel__submit">Montar novo pedido</button>';

    document.getElementById('catalogo-draft-cart-new-order').addEventListener('click', function () {
      successEl.hidden = true;
      form.hidden = false;
      form.reset();
    });
  }

  function bindPanelEvents() {
    document.getElementById('catalogo-draft-cart-fab').addEventListener('click', openPanel);
    document.getElementById('catalogo-draft-cart-close').addEventListener('click', closePanel);
    document.getElementById('catalogo-draft-cart-back').addEventListener('click', closePanel);
    document.getElementById('catalogo-draft-cart-overlay').addEventListener('click', closePanel);
    document.getElementById('catalogo-draft-cart-form').addEventListener('submit', handleFinalizeSubmit);

    document.getElementById('catalogo-draft-cart-items').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove-product]');
      if (!btn) return;
      removeProduct(btn.getAttribute('data-remove-product'));
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && panelIsOpen()) closePanel();
    });

    // Fecha ao clicar em qualquer lugar fora do painel. Não depende só do
    // overlay (que pode ficar atrás de elementos com z-index maior, como a
    // barra fixa do topo) - o clique sempre borbulha até o document.
    //
    // Usa composedPath() em vez de panel.contains(e.target): ações como
    // remover um produto (lixeira) reconstroem o conteúdo do painel
    // (renderPanel) durante o próprio clique, então o elemento clicado já
    // não existe mais na página quando esse listener roda - e .contains()
    // com um elemento removido sempre dá falso, fechando o painel por
    // engano. composedPath() é a lista de elementos por onde o clique
    // passou no momento em que aconteceu, então continua válida mesmo que
    // esses elementos tenham sido removidos/recriados depois.
    document.addEventListener('click', function (e) {
      if (!panelIsOpen()) return;
      var panel = document.getElementById('catalogo-draft-cart-panel');
      var fab = document.getElementById('catalogo-draft-cart-fab');
      var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
      if (path.indexOf(panel) !== -1 || (fab && path.indexOf(fab) !== -1)) return;
      closePanel();
    });
  }

  // Reaplica os valores salvos sempre que novos cards entram no DOM
  // (paginação "Carregar mais" e troca de categoria no filtro).
  function observeNewCards() {
    var list = document.querySelector('[data-catalogo-list]');
    if (!list || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) syncInputsFromState(node);
        });
      });
    });
    observer.observe(list, { childList: true });
  }

  function init() {
    if (!document.querySelector('[data-catalogo-list]')) return;

    loadState();
    buildPanelMarkup();
    bindPanelEvents();
    bindGridInteractions();
    bindGridToggle();
    observeNewCards();
    syncInputsFromState();
    renderPanel();
    updateFloatingButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
